import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73a34374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body d-flex flex-column justify-content-center text-center p-0" }
const _hoisted_2 = {
  class: "fs-1 fw-bolder d-flex justify-content-center thumbnail",
  style: {"min-height":"280px","max-height":"280px","box-shadow":"none","border-radius":"0.475rem 0.475rem 0 0","border-bottom":"1px solid #eff2f5"}
}
const _hoisted_3 = { class: "image-slot" }
const _hoisted_4 = { class: "fs-2x fw-bolder mt-2" }
const _hoisted_5 = { class: "fs-1 mt-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Won the prize ")
const _hoisted_7 = { class: "fs-2 fw-bolder" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" last ")
const _hoisted_9 = { class: "fs-2 fw-bolder" }
const _hoisted_10 = { class: "fs-5 mt-5 mb-5 pb-5 px-5" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.cardClass]),
    style: {"min-height":"300px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          src: _ctx.cardImageSrc,
          class: "align-middle",
          lazy: "",
          fit: "contain",
          style: {"width":"auto","max-width":"100%","height":"auto","max-height":"280px"}
        }, {
          error: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_picture)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.winnerName) + " " + _toDisplayString(_ctx.winnerState), 1),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getPrize), 1),
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getDrawDateFormatted), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (!_ctx.isReadMore(_ctx.draw.id))
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getDescription(100)), 1))
          : _createCommentVNode("", true),
        (_ctx.isReadMore(_ctx.draw.id))
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.getDescription(0)), 1))
          : _createCommentVNode("", true),
        (_ctx.getDescription(0).length > 100)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activateReadMore(_ctx.draw.id))),
              href: "javascript:void(0)"
            }, _toDisplayString(_ctx.toggleCTALabel(_ctx.draw.id)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}